import GeneralHelper from '../../00_utilities/helpers/GeneralHelper';
import AccessibilityHelper from '../../00_utilities/helpers/AccessibilityHelper';

class InfoBox {
    constructor(elem) {
        this.elem = elem;
        this.breakpoints = {
            'screen-xs': 576,
            'screen-sm': 768,
            'screen-md': 992,
            'screen-lg': 1260,
            'screen-xl': 1440,
        };
        this.toggle = this.elem.querySelector('.infobox__toggle');
        this.content = this.elem.querySelector('.infobox__content');
        this.boundCloseListener = this.close.bind(this);
        this.closedStorageKey = `${this.elem.id}-closed`;
    }

    init() {
        if (this.toggle) {
            AccessibilityHelper.addAndHandleLabelsToggle(
                'collapsible', this.toggle, this.content, this.toggle.checked, 'button',
            );

            this.setContentHeight();

            window.addEventListener('resize', GeneralHelper.throttle(() => {
                this.setContentHeight();
            }, 100));

            if (this.elem.classList.contains('info-box--session-closable')
                || this.elem.classList.contains('info-box--minimizable')) {
                const closedInSession = this.getSessionStorage(this.closedStorageKey);

                // only show infobox if it has not already been closed in this session
                if (!closedInSession) {
                    this.initInfo();
                }
            }
        }
    }

    setContentHeight() {
        const content = this.elem.querySelector('.infobox__content');
        const contentHeight = content.scrollHeight;

        this.elem.style.setProperty('--info-box-content-height', `${contentHeight}px`);
    }

    initInfo() {
        this.initClosingHandling();
        this.elem.classList.add('info-box--initialized');
        this.open();
    }

    /**
     * open info-text and set local storage item
     */
    open() {
        this.elem.classList.add('open');
        this.toggle.checked = true;
    }

    /**
     * add closing handler for click and keydown
     */
    initClosingHandling() {
        this.elem.addEventListener('click', this.boundCloseListener);
        this.elem.addEventListener('keydown', this.boundCloseListener);
    }

    /**
     * close infobox and remove event listeners if conditions apply
     * @param event
     */
    close(event) {
        if ((this.toggle.checked || this.elem.classList.contains('open')) && event) {
            const shouldExit = event.target.classList.contains('info-box__toggle') // user clicks on close button
                || event.target.parentNode.classList.contains('info-box__toggle') // user clicks on span in close button
                || event.keyCode === 27; // user hits escape

            if (shouldExit) {
                this.elem.classList.remove('open');
                this.toggle.checked = false;

                // save that info-text was closed in the session
                this.setSessionStorage(this.closedStorageKey, this.elem.id);

                // remove event handlers
                this.elem.removeEventListener('click', this.boundCloseListener);
                this.elem.removeEventListener('keydown', this.boundCloseListener);
            }
        }
    }

    /**
     * get session storage item
     * @param key
     * @returns {string}
     */
    getSessionStorage(key) {
        return sessionStorage.getItem(key);
    }

    /**
     * set session storage item
     * @param key
     * @param value
     */
    setSessionStorage(key, value) {
        sessionStorage.setItem(key, value);
    }
}

export default InfoBox;
